var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2815 57.3929H55.6016V29.9345C55.6016 29.2146 56.1852 28.631 56.9051 28.631H61.7614L54.0795 21.7433C53.8038 21.4961 53.6462 21.1432 53.6462 20.7728V6.20619H47.5664V12.9839C47.5664 13.4983 47.264 13.9646 46.7943 14.1743C46.3244 14.384 45.7754 14.2978 45.3926 13.9544L33.2357 3.05444L4.71013 28.631H9.56628C10.2862 28.631 10.8698 29.2146 10.8698 29.9345V57.3929H24.1899V37.4705C24.1899 36.7506 24.7735 36.167 25.4935 36.167H40.9779C41.6978 36.167 42.2815 36.7506 42.2815 37.4705V57.3929ZM56.9051 60H40.9779C40.2581 60 39.6744 59.4164 39.6744 58.6964V38.7741H26.797V58.6964C26.797 59.4164 26.2133 60 25.4935 60H9.56628C8.84646 60 8.26272 59.4164 8.26272 58.6964V31.2381H1.30353C0.763465 31.2381 0.279192 30.905 0.0861347 30.4004C-0.106923 29.8959 0.0312548 29.3246 0.433403 28.964L32.3656 0.332995C32.8607 -0.110998 33.6107 -0.110998 34.106 0.332995L44.9593 10.0643V4.90263C44.9593 4.18267 45.543 3.59907 46.2628 3.59907H54.9498C55.6696 3.59907 56.2533 4.18267 56.2533 4.90263V20.1908L66.0381 28.964C66.4403 29.3246 66.5785 29.8959 66.3854 30.4004C66.1923 30.905 65.7081 31.2381 65.1679 31.2381H58.2087V58.6964C58.2087 59.4164 57.6249 60 56.9051 60Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSvg);
export default __webpack_public_path__ + "static/media/houseSvg.85dad2796d511399640429f157b7612d.svg";
export { ForwardRef as ReactComponent };